var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.72,
    height: 20.085,
    viewBox: "0 0 24.72 20.085",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download",
    transform: "translate(0 -2.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_163038",
    "data-name": "Path 163038",
    d: "M.772,18a.772.772,0,0,1,.772.772V24.18A1.545,1.545,0,0,0,3.09,25.725H21.63a1.545,1.545,0,0,0,1.545-1.545V18.772a.772.772,0,0,1,1.545,0V24.18a3.09,3.09,0,0,1-3.09,3.09H3.09A3.09,3.09,0,0,1,0,24.18V18.772A.772.772,0,0,1,.772,18Z",
    transform: "translate(0 -4.935)",
    fill: "#63666a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163039",
    "data-name": "Path 163039",
    d: "M11.147,16.772a.772.772,0,0,1,1.092,0l3.542,3.542,3.542-3.542a.772.772,0,0,1,1.092,1.092l-4.088,4.09a.772.772,0,0,1-1.094,0l-4.088-4.09a.772.772,0,0,1,0-1.092Z",
    transform: "translate(-3.422 -4.479)",
    fill: "#63666a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_163040",
    "data-name": "Path 163040",
    d: "M17.647,2.25a.772.772,0,0,1,.772.772v12.36a.772.772,0,1,1-1.545,0V3.022A.772.772,0,0,1,17.647,2.25Z",
    transform: "translate(-5.288)",
    fill: "#63666a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.840f88cc2665c7e27f276a4f5d0735c2.svg";
export { ForwardRef as ReactComponent };